/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The tenant reference ID for SquizRoot.
 */
export const DXP_CONSOLE_SQUIZ_ROOT_REFERENCE_ID = `SquizRoot-0000`;

/**
 * The production DXP domain.
 */
export const DXP_CONSOLE_DOMAIN_PROD = `dxp.squiz.cloud`;

/**
 * The product user fallback text.
 */
export const DXP_CONSOLE_USER_FALLBACK_TEXT = `User`;

/**
 * The not set value text.
 */
export const DXP_CONSOLE_VALUE_NOT_SET = `not set`;

/**
 * The browser storage key for login sessions.
 */
export const DXP_LOCAL_SESSION_KEY = `dxp-local-session`;
